  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-button');
    const panels = document.querySelectorAll('.tab-panel');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const target = button.dataset.tab;

        buttons.forEach((b) => b.classList.remove('active'));
        panels.forEach((p) => p.classList.remove('active'));

        button.classList.add('active');
        document.getElementById('tab-' + target).classList.add('active');
      });
    });
  });